/*
 * @LastEditors: wangyingying162
 * @LastEditTime: 2025-06-05 21:27:30
 * @Author: wangyingying162
 */
// 权益定价类型枚举
export enum PricingTypeEnum {
  LOAN_24 = 1, // 模式一,提现页面不展示权益
  LOAN_24_WITH_RIGHTS = 2, // 模式二,提现页面可展示权益
  LOAN_36 = 3, // 模式三,提现页面不展示权益
  LOAN_24_MUST_RIGHTS = 4, // 模式四,提现页面展示权益内容，引导选择并下单
  LOAN_24_MUST_RIGHTS_OR_LOAN_36 = 5, // 模式五,提现页面同时展示权益，可切换到双融担
  LOAN_24_SELECT_RIGHTS_OR_NOT = 6, // 模式六,提现页面同时展示权益，可切换到纯24
}

// 需要权益的定价类型列表
const PRICING_TYPES_REQUIRE_EQUITY = [
  PricingTypeEnum.LOAN_24_MUST_RIGHTS,
  PricingTypeEnum.LOAN_24_MUST_RIGHTS_OR_LOAN_36,
  PricingTypeEnum.LOAN_24_SELECT_RIGHTS_OR_NOT,
];

// 需要权益的定价类型列表
const PRICING_TYPES_REQUIRE_CALC = [
  PricingTypeEnum.LOAN_24_MUST_RIGHTS_OR_LOAN_36,
  PricingTypeEnum.LOAN_24_SELECT_RIGHTS_OR_NOT,
];


/**
 * 判断给定的定价类型是否需要权益（Equity）作为条件。
 *
 * 需要权益的定价类型包括：
 * - LOAN_24_MUST_RIGHTS (模式四)
 * - LOAN_24_MUST_RIGHTS_OR_LOAN_36 (模式五)
 * - LOAN_24_SELECT_RIGHTS_OR_NOT (模式六)
 *
 * @param pricingType 定价类型枚举值，表示当前的定价策略类型。
 * @returns 如果定价类型属于需要权益的类型，则返回 true；否则返回 false。
 */
export const isEquityRequiredForPricingType = (
  pricingType:PricingTypeEnum,
): boolean => PRICING_TYPES_REQUIRE_EQUITY.includes(pricingType);

/**
 * 权益模型类型枚举
 * 1. ORIGINAL: 旧模型
 * 2. NEW: 新模型
 */
export enum RightsModelTypeEnum {
  ORIGINAL = 1,
  NEW = 2,
}

export enum EquitySelectedEnum {
  NO = '0',
  YES = '1',
}

export const isReCalcRequiredForPricingType = (
  pricingType:PricingTypeEnum,
): boolean => PRICING_TYPES_REQUIRE_CALC.includes(pricingType);

/**
 * 分期商城入口类型枚举
 * 1: 首页入口
 * 2: 订单入口
 * 3: 账单入口
 */
export enum MallEntranceTypeEnum {
  /** 首页入口 */
  HOME = 1,
  /** 订单入口 */
  ORDER = 2,
  /** 账单入口 */
  BILL = 3,
  /** 授信订单入口 */
  CREDIT_ORDER = 4,
}
